import { Card, DatePicker, Select, Table } from 'antd';
import type { Moment } from 'moment';
import moment from 'moment';
import React, { useState } from 'react';
import useSWR from 'swr';

import PageHeader from '@/components/PageHeader';

import { createColumns, pageDataFetcher } from './helpers';
import styles from './styles.module.scss';

const LockerManagement: React.FC = () => {
  const [query, setQuery] = useState<{
    id?: string;
    status?: string;
    time?: [Moment, Moment];
  }>({});

  const { data, error, mutate } = useSWR(
    '/ezcon/api/ultraLocker/backstageLockers',
    pageDataFetcher,
    {
      refreshInterval: 10000,
    }
  );

  if (error) {
    console.error('error', error);
  }

  const columns = createColumns(data?.houseNumbers ?? [], () => {
    mutate();
  });

  const displayLockers = data?.lockers.filter((locker) => {
    if (query.id && locker.id !== query.id) {
      return false;
    }
    if (query.status && locker.status !== query.status) {
      return false;
    }
    if (query.time) {
      return moment(locker.time).isBetween(query.time[0], query.time[1]);
    }
    return true;
  });

  const lockerOptions = data?.lockers
    .map((locker) => ({
      label: locker.name,
      value: locker.id,
    }))
    .sort((a, b) => a.label.localeCompare(b.label));

  const statusOptions = ['空櫃', '使用中', '故障'].map((status) => ({
    label: status,
    value: status,
  }));

  return (
    <div>
      <PageHeader
        title="無人置物櫃管理"
        breadcrumbs={[
          {
            name: '郵件包裹',
          },
          {
            name: '無人置物櫃管理',
          },
        ]}
      />
      <div className={styles.filters}>
        <div>
          <span>櫃位：</span>
          <Select
            placeholder="請選擇置物櫃編號"
            options={lockerOptions}
            allowClear
            value={query.id}
            onChange={(id) => {
              setQuery((prev) => ({ ...prev, id }));
            }}
          />
        </div>
        <div>
          <span>狀態：</span>
          <Select
            placeholder="請選擇狀態"
            options={statusOptions}
            allowClear
            value={query.status}
            onChange={(status) => {
              setQuery((prev) => ({ ...prev, status }));
            }}
          />
        </div>
        <div>
          <span>時間：</span>
          <DatePicker.RangePicker
            placeholder={['起始時間', '結束時間']}
            allowClear
            value={query.time}
            onChange={(time) => {
              if (!time) {
                setQuery((prev) => ({ ...prev, time: undefined }));
                return;
              }
              const [start, end] = time;
              setQuery((prev) => ({
                ...prev,
                time: [moment(start), moment(end)],
              }));
            }}
          />
        </div>
      </div>
      <Card>
        <Table columns={columns} dataSource={displayLockers} bordered />
      </Card>
    </div>
  );
};

export default LockerManagement;
